import React, { useEffect, useRef } from 'react'
import './InputComp.css'
import BookSvg from '../assets/icons/BookSvg'
import UserSvg from '../assets/icons/UserSvg'
import UserCardSvg from '../assets/icons/UserCardSvg'
// import Calendar from '../assets/icons/Calendar'
import PhoneGreenSvg from '../assets/icons/PhoneGreenSvg'
import Inputmask from 'inputmask' // Input mask kütüphanesini ekliyoruz

const InputComp = ({
  label,
  name = '',
  value,
  onChange,
  placeholder,
  error,
  type = 'text',
  pattern = '',
  maxlength = '1000',
  svg = null,
  mask = '', // Maske özelliği ekliyoruz
  errorText = '*Bu Alan Zorunludur.',
}) => {
  const svgs = (svg) => {
    switch (svg) {
      case 'Book':
        return <BookSvg width={'.9rem'} />
      case 'User':
        return <UserSvg width={'.9rem'} />
      case 'UserCard':
        return <UserCardSvg width={'.9rem'} />
      case 'Phone':
        return <PhoneGreenSvg width={'.9rem'} />

      default:
        return <UserCardSvg width={'.9rem'} />
    }
  }

  const inputRef = useRef(null)

  // Masking işlemini yapıyoruz
  useEffect(() => {
    if (mask && inputRef.current) {
      const im = new Inputmask(mask)
      im.mask(inputRef.current)
    }
  }, [mask])

  return (
    <div className='inputDiv'>
      <div style={{ position: 'relative', width: '100%' }}>
        {svg && <div style={{ position: 'absolute', top: '8px', left: '20px' }}>{svgs(svg)}</div>}

        <input
          ref={inputRef} // Input'a referans ekliyoruz
          label={type === 'radio' ? label : null}
          pattern={pattern}
          maxLength={maxlength}
          type={type}
          name={name}
          value={value}
          style={{
            padding: svg ? '0.5rem 1rem 0.5rem 2.6rem' : '0.5rem 1rem 0.5rem 1rem',
            borderColor: error ? 'red' : '#BCD8CC',
          }}
          onChange={onChange}
          placeholder={placeholder}
        />
      </div>

      {error && (
        <div
          style={{
            marginTop: '0.1rem',
            marginLeft: '0.5rem',
            fontSize: '9px',
            color: 'red',
          }}
        >
          {errorText}
        </div>
      )}
    </div>
  )
}

export default InputComp
